import { Component } from '@angular/core';

@Component({
    selector: 'app-dossieparticipante',
    templateUrl: './dossieparticipante.component.html',
    styleUrls: ['./dossieparticipante.component.scss']
  })
  export class dossieparticipanteComponent {}